import { CodespacesIcon, GitPullRequestClosedIcon, IdBadgeIcon, TasklistIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useState } from "react";
import { sf_tbtp_viewmodel } from "../../../../models/response/tbtp/sf_tbtp";
import { EditTBTPHachToan } from "../edit_tbtp_hachtoan";
import { EditTBTPKhoanNop } from "../edit_tbtp_khoannop";
import DangKyDichVuHocSinh from "./DangKyDichVuHocSinh";
import HinhThucMienGiam from "./HinhThucMienGiam";
import QuyetToanHocSinh from "./QuyetToanHocSinh";
type TbtpEditLayoutTabProps = {
    sf_tbtp: sf_tbtp_viewmodel,
    onCancel: (isMustReload: boolean) => void,
    isReadOnly?: boolean
}
const TbtpEditLayoutTab = (props: TbtpEditLayoutTabProps) => {
    const [isMustReload, SetIsMustReload] = useState<boolean>(false);
    const [selectedTab, setSelectedTab] = useState<"khoannop" | "quyettoan" | "miengiam" | "dichvu">("khoannop");

    return (
        <Box>
            <UnderlineNav aria-label="tabs">

                <UnderlineNav.Item
                    icon={TasklistIcon}
                    aria-current={selectedTab === "khoannop" ? "page" : undefined}
                    onClick={() => setSelectedTab("khoannop")}
                >
                    Thông tin khoản nộp
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={CodespacesIcon}
                    aria-current={selectedTab === "dichvu" ? "page" : undefined}
                    onClick={() => setSelectedTab("dichvu")}
                >
                    Thông tin dịch vụ
                </UnderlineNav.Item>
                <UnderlineNav.Item
                    icon={GitPullRequestClosedIcon}
                    aria-current={selectedTab === "miengiam" ? "page" : undefined}
                    onClick={() => setSelectedTab("miengiam")}
                >
                    Thông tin miễn giảm
                </UnderlineNav.Item>

                <UnderlineNav.Item
                    icon={IdBadgeIcon}
                    aria-current={selectedTab === "quyettoan" ? "page" : undefined}
                    onClick={() => setSelectedTab("quyettoan")}
                >
                    Thông tin quyết toán
                </UnderlineNav.Item>

            </UnderlineNav>
            <Box>
                {selectedTab === "khoannop" &&
                    <Box>
                        <Box>
                            <EditTBTPKhoanNop
                                sf_tbtp_viewmodel={props.sf_tbtp}
                                onChanged={() => { SetIsMustReload(true) }}
                                isReadOnly={props.isReadOnly}
                            />
                        </Box>
                        <Box sx={{ m: 1 }}>
                            <EditTBTPHachToan
                                sf_tbtp_viewmodel={props.sf_tbtp}
                                onChanged={() => { SetIsMustReload(true) }}
                                isReadOnly={props.isReadOnly}
                            />
                        </Box>
                    </Box>
                }
            </Box>
            <Box>
                {selectedTab === "quyettoan" &&
                    <QuyetToanHocSinh ts_hocsinh_id={props.sf_tbtp.ts_hocsinh_id}
                    />
                }
            </Box>
            <Box>
                {selectedTab === "miengiam" &&
                    <HinhThucMienGiam ts_hocsinh_id={props.sf_tbtp.ts_hocsinh_id}
                    />
                }
            </Box>
            <Box>
                {selectedTab === "dichvu" &&
                    <DangKyDichVuHocSinh ts_hocsinh_id={props.sf_tbtp.ts_hocsinh_id}
                    />
                }
            </Box>
        </Box>
    );
};

export default TbtpEditLayoutTab;
